var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$route.query.page || (_vm.$route.query.page && _vm.token))?_c('div',[_c('div',[_c('HomeView',{on:{"login":_vm.login,"register":_vm.register}})],1)]):_c('div',[_c('Auth',{on:{"login":_vm.login,"register":_vm.register}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }